module.exports = __webpack_public_path__ + "img/item_gift_certificate.081bfc8d.jpg";